__turbopack_context__.v({
  "error": "CreateWalletWelcome-module__c5UZQG__error",
  "logo": "CreateWalletWelcome-module__c5UZQG__logo",
  "root": "CreateWalletWelcome-module__c5UZQG__root",
});
